import { IAnalyticsTargetedEventsTracker } from '@verv-inc/js-toolkit';
import { GTMOnboardingFunnelEvent, EVENT_TRACKERS, VervBIEvent } from 'utils/analytics';

export const sendAnalyticsEvents = (
	eventsTracker: IAnalyticsTargetedEventsTracker,
	versionPayment: string,
) => {
	void eventsTracker.trackWithTarget(
		GTMOnboardingFunnelEvent.showTrialPopup(versionPayment),
		EVENT_TRACKERS.GTM,
	);
};

export const sendAnalyticsEventsSelectSubscription = (
	eventsTracker: IAnalyticsTargetedEventsTracker,
	productName: string,
) => {
	void eventsTracker.trackWithTarget(
		GTMOnboardingFunnelEvent.selectSubscription(productName),
		EVENT_TRACKERS.GTM,
	);
};
